import { render, staticRenderFns } from "./verifiedList.vue?vue&type=template&id=6cfa2032&scoped=true&"
import script from "./verifiedList.vue?vue&type=script&lang=js&"
export * from "./verifiedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfa2032",
  null
  
)

export default component.exports